import type { OrderType } from '@/store/server/common/order/order.dto';

// URL slug = /championsrun (2026-10-22 확정, Figma URL 표 569:6688). 변경 시 SSOT docs/fcseoul-run/README.md §6.
//    경로 문자열은 이 파일의 상수로만 참조하고, 컴포넌트에 경로를 직접 쓰지 않는다.
const BASE_PATH = '/championsrun';

/** 1:1 문의 공통코드(QC) 이름. qna 목록·작성에서 이 이름으로 카테고리를 고정한다. */
export const FCSEOUL_RUN_QNA_CATEGORY = '챔피언스런';

export const FCSEOUL_RUN_TAB = ['run', 'chilsung'] as const;
export type FcseoulRunTab = (typeof FCSEOUL_RUN_TAB)[number];

/** 참가권 등록 관리 탭 — order: 구매한 참가권 / register: 참가권 직접 등록 */
export const FCSEOUL_RUN_TICKET_TAB = ['order', 'register'] as const;
export type FcseoulRunTicketTab = (typeof FCSEOUL_RUN_TICKET_TAB)[number];

/** 참가권 등록 관리 → 내 참가 현황 복귀 표시. 이 값이 있으면 등록 0개여도 관리 화면으로 자동 이동하지 않는다 (SB 06-01). */
export const FCSEOUL_RUN_FROM_TICKET = 'ticket';

// 경로는 Figma URL 표(569:6688) 기준. my·tickets·records 는 (brand)/(private) 그룹(로그인 필수·noindex).
const MY_PATH = `${BASE_PATH}/my`;
const TICKETS_PATH = `${BASE_PATH}/tickets`;
const RECORDS_PATH = `${BASE_PATH}/records`;

export const FCSEOUL_RUN_ROUTES = {
  main: BASE_PATH,
  eventTab: `${BASE_PATH}?tab=chilsung`,
  /** 참가 신청 — 키트 스토어 상세 (Figma 520:341) */
  store: `${BASE_PATH}/store`,
  /** 내 참가 현황 (SB 06) */
  myStatus: MY_PATH,
  /** 내 참가 현황 — 선택 참가권 지정 */
  myStatusOf: (code: string) => `${MY_PATH}?code=${encodeURIComponent(code)}`,
  /** 참가권 등록 관리에서 돌아올 때 — 등록 0개여도 빈 화면을 보여 준다 */
  myStatusFromTicket: `${MY_PATH}?from=${FCSEOUL_RUN_FROM_TICKET}`,
  /** 참가권 등록 관리 (SB 06-0). 기본 탭 = 구매한 참가권 */
  myTicket: (tab: FcseoulRunTicketTab = 'order') => (tab === 'order' ? TICKETS_PATH : `${TICKETS_PATH}?tab=${tab}`),
  /** 러닝 기록 인증·수정 경로 접두사 — 하단 고정 바 여백 판단용 */
  recordPrefix: `${RECORDS_PATH}/`,
  /** 러닝 기록 인증 (SB 07 신규) */
  recordNew: (code: string) => `${RECORDS_PATH}/${encodeURIComponent(code)}`,
  /** 러닝 기록 수정 (SB 07 B-03) */
  recordEdit: (code: string, recordIdx: number) => `${RECORDS_PATH}/${encodeURIComponent(code)}/${recordIdx}`,
  orderSuccess: (type: OrderType, orderId: string) => `${BASE_PATH}/order/success/${type}/${orderId}`,
  /** 런 페이지의 1:1 문의는 목록으로 진입한다 (2026-10-19 결정). categoryName 으로 카테고리 고정. */
  inquiry: `/support/qna/list?categoryName=${encodeURIComponent(FCSEOUL_RUN_QNA_CATEGORY)}`,
  mypageOrder: (type: OrderType) => `/mypage/order/${type}`,
} as const;
